import { css, forBrands, getFont } from '@core-ui/react-stitch';
import { DefaultStyleFn } from '@src/types/buttonVariant';

export const getModalStyles: DefaultStyleFn = ({ theme }) => {
  const brandStyles = forBrands(theme, {
    gap: ({ color }) => css`
      ${getFont('secondary')({ theme })}
      border: 2px solid ${color.b2};
      color: ${color.b2};
      font-size: 1.067rem;
      padding: 0.59em;
    `,
    gapfs: ({ color }) => css`
      ${getFont('secondary')({ theme })}
      border: 2px solid ${color.b2};
      color: ${color.b2};
      font-size: 1.067rem;
      padding: 0.59em;
    `,
    on: ({ color }) => css`
      ${getFont('secondary')({ theme })}
      background-color: ${color.g2};
      color: #ffffff;
      font-size: 1.2rem;
      padding: 0.5em;
      &:hover {
        background-color: ${color.g3};
      }
    `,
    br: ({ color }) => css`
      ${getFont('secondary')({ theme })}
      font-size: 1.0625rem;
      padding: 0.48em;
      line-height: 1.25;
      background-color: ${color.alpha00};
      border: 1px solid ${color.g1};
      &:hover {
        color: ${color.gray80};
        border-color: ${color.gray80};
      }
    `,
    brfs: ({ color }) => css`
      ${getFont('secondary')({ theme })}
      font-size: 1.0625rem;
      padding: 0.48em;
      line-height: 1.25;
      background-color: ${color.alpha00};
      border: 1px solid ${color.g1};
      &:hover {
        color: ${color.gray80};
        border-color: ${color.gray80};
      }
    `,
    at: ({ color }) => css`
      background-color: ${color.g2};
      color: #ffffff;
      font-size: 1.2rem;
      padding: 0.52em;
      &:hover {
        background-color: ${color.gray50};
      }
      &[disabled] {
        background-color: ${color.g5};
      }
    `,
  });

  return css`
    text-align: center;
    padding: 0.5rem;
    max-width: 8.75rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    &[disabled] {
      opacity: 0.5;
    }
    ${brandStyles}
  `;
};
